// Mock data for Alberta Pharmacy Supplies - Immediately Available Products

export const heroData = {
  title: "Alberta Pharmacy Supplies",
  subtitle: "Your One-Stop Shop for Quality Pharmacy Supplies",
  description: "Immediate stock availability • Local Calgary service • Competitive pricing",
  features: [
    "Lowest prices in Alberta - Guaranteed",
    "Next day Calgary delivery",
    "Dedicated Account Manager"
  ]
};

export const immediatelyAvailableProducts = [
  {
    id: "TCV-13",
    name: "Thumb Click Reversible Cap Vials - 13 DRAM",
    category: "Thumb Click Vials",
    capacity: "13 DRAMS (1.63 OZ, 48 ML)",
    material: "Clarified Polypropylene",
    features: ["Child Resistant", "Airtight", "Reversible Cap", "Moisture Resistant"],
    colors: ["Clear", "Amber", "Blue", "Purple", "Green", "White", "Black"],
    inventory: {
      unitsPerCase: 215,
      pricePerUnit: 0.05,
      minimumOrder: 80,
      totalUnits: 22000
    },
    specifications: {
      diameter: '1.53"',
      height: '2.56"',
      capType: "Thumb Click, Push Tab down and Turn Caps, Reversible"
    },
    status: "immediately_available",
    image: "https://customer-assets.emergentagent.com/job_meds-storage/artifacts/dvvkdhbg_image.png"
  },
  {
    id: "TCV-16",
    name: "Thumb Click Reversible Cap Vials - 16 DRAM",
    category: "Thumb Click Vials",
    capacity: "16 DRAMS (2 OZ, 58 ML)",
    material: "Clarified Polypropylene",
    features: ["Child Resistant", "Airtight", "Reversible Cap", "Moisture Resistant"],
    colors: ["Clear", "Amber", "Blue", "Purple", "Green", "White", "Black"],
    inventory: {
      unitsPerCase: 175,
      pricePerUnit: 0.07,
      minimumOrder: 10,
      totalUnits: 1750
    },
    specifications: {
      diameter: '1.53"',
      height: '3.03"',
      capType: "Thumb Click, Push Tab down and Turn Caps, Reversible"
    },
    status: "immediately_available",
    image: "https://customer-assets.emergentagent.com/job_meds-storage/artifacts/dvvkdhbg_image.png"
  },
  {
    id: "CR-06",
    name: "Push Down & Turn Cap Vials - 6 DRAM",
    category: "Child Resistant Vials",
    capacity: "6 DRAMS (0.75 OZ, 21 ML)",
    material: "Clarified Polypropylene",
    features: ["Child Resistant", "Push Down & Turn", "Airtight", "Moisture Resistant"],
    colors: ["Clear", "Amber", "Blue", "Purple", "Green", "White", "Black"],
    inventory: {
      unitsPerCase: 600,
      pricePerUnit: 0.03,
      minimumOrder: 85,
      totalUnits: 51000
    },
    specifications: {
      diameter: '0.94"',
      height: '2.47"',
      capType: "Push Down and Turn Caps, Child Resistant"
    },
    status: "immediately_available",
    popular: true,
    image: "https://customer-assets.emergentagent.com/job_meds-storage/artifacts/almnlitm_image.png"
  },
  {
    id: "CR-08",
    name: "Push Down & Turn Cap Vials - 8 DRAM",
    category: "Child Resistant Vials",
    capacity: "8 DRAMS (1.00 OZ, 29 ML)",
    material: "Clarified Polypropylene",
    features: ["Child Resistant", "Push Down & Turn", "Airtight", "Moisture Resistant"],
    colors: ["Clear", "Amber", "Blue", "Purple", "Green", "White", "Black"],
    inventory: {
      unitsPerCase: 440,
      pricePerUnit: 0.03,
      minimumOrder: 85,
      totalUnits: 34650
    },
    specifications: {
      diameter: '1.00"',
      height: '2.60"',
      capType: "Push Down and Turn Caps, Child Resistant"
    },
    status: "immediately_available",
    popular: true,
    image: "https://customer-assets.emergentagent.com/job_meds-storage/artifacts/almnlitm_image.png"
  },
  {
    id: "CR-13",
    name: "Push Down & Turn Cap Vials - 13 DRAM",
    category: "Child Resistant Vials",
    capacity: "13 DRAMS (1.63 OZ, 48 ML)",
    material: "Clarified Polypropylene",
    features: ["Child Resistant", "Push Down & Turn", "Airtight", "Moisture Resistant"],
    colors: ["Clear", "Amber", "Blue", "Purple", "Green", "White", "Black"],
    inventory: {
      unitsPerCase: 310,
      pricePerUnit: 0.04,
      minimumOrder: 60,
      totalUnits: 18600
    },
    specifications: {
      diameter: '1.50"',
      height: '2.55"',
      capType: "Push Down and Turn Caps, Child Resistant"
    },
    status: "immediately_available",
    image: "https://customer-assets.emergentagent.com/job_meds-storage/artifacts/almnlitm_image.png"
  },
  {
    id: "CR-20",
    name: "Push Down & Turn Cap Vials - 20 DRAM",
    category: "Child Resistant Vials",
    capacity: "20 DRAMS (2.50 OZ, 73 ML)",
    material: "Clarified Polypropylene",
    features: ["Child Resistant", "Push Down & Turn", "Airtight", "Moisture Resistant"],
    colors: ["Clear", "Amber", "Blue", "Purple", "Green", "White", "Black"],
    inventory: {
      unitsPerCase: 400,
      pricePerUnit: 0.05,
      minimumOrder: 30,
      totalUnits: 12000
    },
    specifications: {
      diameter: '1.77"',
      height: '2.26"',
      capType: "Push Down and Turn Caps, Child Resistant"
    },
    status: "immediately_available",
    image: "https://customer-assets.emergentagent.com/job_meds-storage/artifacts/almnlitm_image.png"
  },
  {
    id: "RCV-08",
    name: "Reversible Cap Vials - 8 DRAM",
    category: "Reversible Cap Vials",
    capacity: "8 DRAMS (1 OZ, 29 ML)",
    material: "Clarified Polypropylene",
    features: ["Dual Purpose Cap", "Child Resistant", "Push-down/Turn & Non-lock Screw", "Airtight"],
    colors: ["Clear", "Amber", "Blue", "Purple", "Green", "White", "Black"],
    inventory: {
      unitsPerCase: 440,
      pricePerUnit: 0.04,
      minimumOrder: 80,
      totalUnits: 32800
    },
    specifications: {
      diameter: '1.00"',
      height: '2.65"',
      capType: "Dual purpose (Push-down/turn & non-lock screw)"
    },
    status: "immediately_available",
    popular: true,
    image: "https://customer-assets.emergentagent.com/job_meds-storage/artifacts/5q782q8p_image.png"
  },
  {
    id: "RCV-13",
    name: "Reversible Cap Vials - 13 DRAM",
    category: "Reversible Cap Vials",
    capacity: "13 DRAMS (1.63 OZ, 48 ML)",
    material: "Clarified Polypropylene",
    features: ["Dual Purpose Cap", "Child Resistant", "Push-down/Turn & Non-lock Screw", "Airtight"],
    colors: ["Clear", "Amber", "Blue", "Purple", "Green", "White", "Black"],
    inventory: {
      unitsPerCase: 275,
      pricePerUnit: 0.05,
      minimumOrder: 80,
      totalUnits: 22000
    },
    specifications: {
      diameter: '1.30"',
      height: '2.70"',
      capType: "Dual purpose (Push-down/turn & non-lock screw)"
    },
    status: "immediately_available",
    image: "https://customer-assets.emergentagent.com/job_meds-storage/artifacts/5q782q8p_image.png"
  },
  {
    id: "RCV-20",
    name: "Reversible Cap Vials - 20 DRAM",
    category: "Reversible Cap Vials",
    capacity: "20 DRAMS (2.5 OZ, 73 ML)",
    material: "Clarified Polypropylene",
    features: ["Dual Purpose Cap", "Child Resistant", "Push-down/Turn & Non-lock Screw", "Airtight"],
    colors: ["Clear", "Amber", "Blue", "Purple", "Green", "White", "Black"],
    inventory: {
      unitsPerCase: 270,
      pricePerUnit: 0.06,
      minimumOrder: 40,
      totalUnits: 10800
    },
    specifications: {
      diameter: '1.68"',
      height: '2.60"',
      capType: "Dual purpose (Push-down/turn & non-lock screw)"
    },
    status: "immediately_available",
    image: "https://customer-assets.emergentagent.com/job_meds-storage/artifacts/5q782q8p_image.png"
  },
  {
    id: "OJ-100",
    name: "Ointment Jar - 8 OZ",
    category: "Ointment Jars",
    capacity: "8 OZ (240 ML)",
    material: "Natural Plastic",
    features: ["Screw top closure", "Pharmaceutical packing", "Cosmetic grade", "Wide mouth"],
    colors: ["Natural", "Clear", "Amber", "Custom colors available"],
    inventory: {
      unitsPerCase: 48,
      pricePerUnit: 0.71,
      minimumOrder: 48,
      totalUnits: 480
    },
    specifications: {
      diameter: '2.76"',
      height: '2.60"',
      capType: "Screw top"
    },
    status: "immediately_available",
    popular: true,
    image: "https://customer-assets.emergentagent.com/job_pharmacy-supplies/artifacts/q4cnb0ep_image.png"
  },
  {
    id: "OJ-400",
    name: "Ointment Jar - 16 OZ",
    category: "Ointment Jars",
    capacity: "16 OZ (475 ML)",
    material: "Natural Plastic",
    features: ["Screw top closure", "Pharmaceutical packing", "Cosmetic grade", "Wide mouth"],
    colors: ["Natural", "Clear", "Amber", "Custom colors available"],
    inventory: {
      unitsPerCase: 48,
      pricePerUnit: 0.942,
      minimumOrder: 48,
      totalUnits: 480
    },
    specifications: {
      diameter: '3.54"',
      height: '2.95"',
      capType: "Screw top"
    },
    status: "immediately_available",
    popular: false,
    image: "https://customer-assets.emergentagent.com/job_pharmacy-supplies/artifacts/q4cnb0ep_image.png"
  }
];

export const productCategories = [
  {
    id: "thumb_click",
    name: "Thumb Click Vials",
    description: "One-click closure with reversible caps",
    count: immediatelyAvailableProducts.filter(p => p.category === "Thumb Click Vials").length
  },
  {
    id: "child_resistant",
    name: "Child Resistant Vials",
    description: "Push down & turn safety caps",
    count: immediatelyAvailableProducts.filter(p => p.category === "Child Resistant Vials").length
  },
  {
    id: "reversible_cap",
    name: "Reversible Cap Vials",
    description: "Dual-purpose cap system",
    count: immediatelyAvailableProducts.filter(p => p.category === "Reversible Cap Vials").length
  },
  {
    id: "ointment_jars",
    name: "Ointment Jars",
    description: "Pharmaceutical and cosmetic grade jars",
    count: immediatelyAvailableProducts.filter(p => p.category === "Ointment Jars").length
  }
];

export const companyInfo = {
  name: "Alberta Pharmacy Supplies",
  tagline: "Your trusted partner for quality pharmacy supplies",
  location: "Calgary and surrounding area",
  phone: "(403) 875-5175",
  email: "sales@ap-supply.ca",
  services: [
    "Next day delivery in Calgary and surrounding area",
    "Rush order processing",
    "Volume discount pricing"
  ]
};